import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Spacing } from "@snapchat/snap-design-system";

import triangleDownSvg from "@app-assets/svg/triangle-down.svg";
import triangleUpSvg from "@app-assets/svg/triangle-up.svg";

import { HeaderItem } from "../../../../shared/components";

export const ClickableHeaderItem = styled(HeaderItem)`
    cursor: pointer;
    user-select: none; /* supported by Chrome and Opera */
`;

export const sortIconAsc = css`
    padding: 0 ${Spacing.SM}px;
    background: url(${triangleDownSvg}) no-repeat center;
    background-size: contain;
`;

export const sortIconDesc = css`
    padding: 0 ${Spacing.SM}px;
    background: url(${triangleUpSvg}) no-repeat center;
    background-size: contain;
`;
